import {clearString, getAlphabet,makeSpaceless, rotateAlphabet} from "../helpers/stringHelpers";

const SEPARATOR = ''

export const methods = {
    cypher: function (input, hasCh = false, missing = [], params, sep = SEPARATOR) {
        let cyphered = []
        let cleared = clearString(input, hasCh)
        missing.forEach((char) => {
            if (char !== 'ch')
                cleared = cleared.replaceAll(char, '')
        })
        let alphabet = getAlphabet(hasCh);
        // eslint-disable-next-line use-isnan
        let keyChar = isNaN(parseInt(params[1].toLowerCase())) ? alphabet.indexOf(params[1].toLowerCase()) : parseInt(params[1].toLowerCase());
        if(keyChar<0){
            keyChar = 0;
        }
        let characters = cleared.split('');
        let charactersSpaceLess = cleared.replaceAll(/[.,\-_=?! ]/g,'').split('');
        let fake_i = 0
        for (let i = 0; i < characters.length; i++) {
            let char = characters[i];
            let prevChar = charactersSpaceLess[fake_i- 1];
            if (char.match(/[.,?! ]/)) {
                cyphered.push(char);
            } else {
                let chr = rotateAlphabet(alphabet.indexOf(prevChar), hasCh)[alphabet.indexOf(char)];
                if (i == 0) {
                    chr = rotateAlphabet(keyChar, hasCh)[alphabet.indexOf(char)];
                }
                cyphered.push(chr);
                fake_i++;
            }

        }

        return cyphered.join(sep)
            .replaceAll('*', 'ch')
    },
    decypher: function (input, hasCh = false, missing = [], params) {
        let deciphered = []
        let decipheredSpaceless = []
        let cleared = clearString(input, hasCh)
        let alphabet = getAlphabet(hasCh);
        // eslint-disable-next-line use-isnan
        // let keyChar = !isNaN(parseInt(params[1])) ? alphabet.indexOf(params[1]) : 0;
        let keyChar = isNaN(parseInt(params[1].toLowerCase())) ? alphabet.indexOf(params[1].toLowerCase()) : parseInt(params[1].toLowerCase());
        if(keyChar<0){
            keyChar = 0;
        }
        let characters = cleared.split('');
        let fake_i = -1
        for (let i = 0; i < characters.length; i++) {
            let char = characters[i];
            let prevChar = decipheredSpaceless[fake_i];
            if (char.match(/[.,?! ]/)) {
                deciphered.push(char);
            } else {
                let chr = (i == 0 ?
                    alphabet[rotateAlphabet(keyChar, hasCh).indexOf(char)] :
                    alphabet[rotateAlphabet(alphabet.indexOf(prevChar), hasCh).indexOf(char)]);
                deciphered.push(chr);
                decipheredSpaceless = makeSpaceless(deciphered.join('').replaceAll('*', 'ch')).split('');
                fake_i++;
            }

        }
        return deciphered.join('').replaceAll('*', 'ch')
    },
};

export default {...methods,SEPARATOR}